import React from "react";
import GoogleAuth from "./GoogleAuth";
import { useTranslation } from "react-i18next";
import FacebookAuth from "./FacebookAuth";
const index = () => {
  const { t } = useTranslation();
  return (
    <>
      <div
        style={{
          borderTop: "1px solid",
          borderRadius: "5px",
          padding: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <span
          style={{
            width: "100%",
            minWidth: "500px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            flexWrap: "wrap",
            margin: "5px"
          }}
        >
          <span
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start",
              flexWrap: "wrap",
              justifyContent: "center",
              opacity: "0.7"
            }}
          >
            <h4>{t("Social Authentication")}</h4>
          </span>
          <span
            style={{
              width: "50%",
              minWidth: "400px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              flexWrap: "wrap",
              margin: "5px"
            }}
          >
            <GoogleAuth />
            <FacebookAuth/>
          </span>
        </span>
      </div>
    </>
  );
};

export default index;
